// Layout and font size management
import { currentLayout, currentFontSize, setCurrentLayout, setCurrentFontSize } from './state.js';
import { renderStories, applyLayout } from './stories.js';

export function changeLayout(layout) {
  setCurrentLayout(layout);
  applyLayout();
  updateLayoutToggle();
  renderStories();
}

export function toggleLayout() {
  changeLayout(currentLayout === 'list' ? 'grid' : 'list');
}

export function updateLayoutToggle() {
  const toggle = document.getElementById('layout-toggle');
  const label = toggle?.querySelector('.layout-toggle-label');
  if (!toggle) return;

  if (currentLayout === 'list') {
    toggle.classList.remove('show-list');
    if (label) label.textContent = 'Grid view';
  } else {
    toggle.classList.add('show-list');
    if (label) label.textContent = 'List view';
  }

  document.querySelectorAll('.layout-option input[name="layout"]').forEach(radio => {
    radio.checked = radio.value === currentLayout;
  });
}

export function changeFontSize(size) {
  setCurrentFontSize(size);
  applyFontSize();
  updateFontSizeSelector();
}

export function applyFontSize() {
  document.documentElement.removeAttribute('data-font-size');
  if (currentFontSize !== 'medium') {
    document.documentElement.setAttribute('data-font-size', currentFontSize);
  }
}

export function updateFontSizeSelector() {
  document.querySelectorAll('.font-size-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.size === currentFontSize);
  });
}
